"use client";

import { Columns3, List } from "lucide-react";

/** The comparison's two views. */
export type ComparisonView = "list" | "table";

const OPTIONS: { value: ComparisonView; label: string; icon: typeof List }[] = [
  { value: "list", label: "List", icon: List },
  { value: "table", label: "Side by side", icon: Columns3 },
];

/**
 * A quiet icon switch between the ranked list and the side-by-side table, sized like the Per
 * person / Total switch beside it.
 * @param props.value - The view showing.
 * @param props.onChange - Switches view.
 * @returns The switch.
 * @throws Never.
 */
export const ViewToggle = ({
  value,
  onChange,
}: {
  value: ComparisonView;
  onChange: (view: ComparisonView) => void;
}) => (
  <div role="group" aria-label="View" className="inline-flex rounded-full border border-gray-200 p-0.5">
    {OPTIONS.map(({ value: option, label, icon: Icon }) => (
      // ui-lint-disable-next-line raw-control: a custom control (segment, chip, calendar day, stepper, icon or inline editor) styled to its row; FetchButton's sizes and 3D treatment don't fit
      <button
        key={option}
        type="button"
        aria-pressed={value === option}
        aria-label={label}
        title={label}
        onClick={() => onChange(option)}
        className="relative flex h-6 w-8 items-center after:absolute after:-inset-x-1.5 after:-inset-y-2.5 after:content-[''] justify-center rounded-full text-gray-500 transition-colors hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 aria-pressed:bg-gray-100 aria-pressed:text-gray-900"
      >
        <Icon aria-hidden className="size-3.5" />
      </button>
    ))}
  </div>
);
